import { useEffect, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";
import Seo from "../components/Seo";

export default function InfoPage({ slug }) {
  const [page, setPage] = useState(null);

  useEffect(() => { api(`/pages/${slug}`).then(setPage).catch(() => setPage({ title: "Page", sections: [], unpublished: true })); }, [slug]);

  if (!page) return <div className="py-40 text-center text-muted font-bold bg-candy-mist min-h-screen">Loading…</div>;

  return (
    <div className="bg-candy-mist min-h-screen">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-14">
        <Seo title={page.title} description={page.intro} path={`/${slug}`} noindex={page.unpublished} />
        <Reveal>
          <h1 data-testid={`page-${slug}-heading`} className="font-display font-semibold text-3xl sm:text-4xl text-center">{page.title}</h1>
          {page.intro && <p className="text-center text-ink/70 font-semibold mt-3">{page.intro}</p>}
        </Reveal>
        {page.unpublished && (
          <div className="mt-8 flex gap-3 items-start bg-butter-soft border border-butter-accent/50 rounded-2xl p-4" data-testid={`page-${slug}-draft-notice`}>
            <ShieldAlert className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
            <p className="text-sm font-semibold text-ink/80">This page is a <strong>draft</strong> — the owner reviews and publishes it from the admin panel before it becomes an official policy.</p>
          </div>
        )}
        <div className="mt-10 space-y-8" data-testid={`page-${slug}-sections`}>
          {(page.sections || []).map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <h2 className="font-display font-semibold text-xl">{s.heading}</h2>
              <p className="mt-2 text-ink/70 font-semibold leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
          {(!page.sections || page.sections.length === 0) && <p className="text-center text-muted font-semibold">This page is being written as we speak.</p>}
        </div>
      </div>
    </div>
  );
}
